import Model from '@/models/Model'

export default class Comment extends Model {

    resource()
    {
    return 'pos_sale'
    }
}